// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sGGfH{padding-top:12px}.bUp_F{padding-top:12px}.SLwai{display:flex;gap:24px;align-items:flex-start}.SLwai ._UuFq{width:100%}.SLwai .ypxOu{display:none}.SLwai .WIwpQ{flex-shrink:0}.SLwai .WIwpQ img{max-width:120px;max-height:76px;object-fit:contain}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionButton": `sGGfH`,
	"kybNote": `bUp_F`,
	"logoStepContainer": `SLwai`,
	"logoStepContent": `_UuFq`,
	"logoPicker": `ypxOu`,
	"logoPreview": `WIwpQ`
};
export default ___CSS_LOADER_EXPORT___;
